import { ContactUsItemCombinedProps } from './types';

const usePresenter = (props: ContactUsItemCombinedProps): ContactUsItemCombinedProps => {
  return props;
};

export default usePresenter;
